import AuthProvider, {
  useAuth,
} from './AuthProvider'

export default AuthProvider

export {
  useAuth,
}
